var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "13px",
    viewBox: "0 0 17 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_material") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2699\\uFE0F-Admin-(Desktop)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reporting",
    transform: "translate(-84, -549)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(66, 526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8028399,23 L28.7998236,23.0036436 C28.7467588,23.0036682 28.6959725,23.0235847 28.6589093,23.0588878 L18,33.2129799 L18,35.1428571 L28.1216919,35.1428571 L34.8784763,24.805898 C34.8952462,24.7802454 34.904969,24.7511462 34.9067969,24.7211853 L34.9996801,23.1934284 C35.0060648,23.0883562 34.9160693,23 34.8028399,23 L34.8028399,23 Z M27.6876368,34.7395059 L18.4340551,34.7395059 L18.4340551,33.6163312 L27.6876368,33.6163312 L27.6876368,34.7395059 Z",
    id: "icon_material"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaterial);
export default __webpack_public_path__ + "static/media/icon_material.ff04309aeb27c71f078ed9df58ca9a7a.svg";
export { ForwardRef as ReactComponent };